<!--
  *** 开发人员: 本页面:王臣; 其他页面暂时性维护.
  *** 开发时间: 2024-05-30
  *** 功能描述: 全链预警-行业景气详情
  *** 版本号: v1.0.0
  *** 版权所有: 上海大智慧信息科技有限公司，并保留所有权利。
 -->
<template>
  <div class="HyqjDetail" :style="!isVip3062 && !isVip504 && !isVip6yuan ? 'height: 100vh;overflow: hidden;' : ''">
    <div class="nav_bar">
      <van-nav-bar title="行业景气" left-arrow @click-left="onClickLeft" />
    </div>
    <div class="card">
      <p class="h1">{{ urlItem && urlItem.factor ? urlItem.factor.indexname : "--" }}</p>

      <div class="info">
        <van-row>
          <van-col span="12">
            <van-row>
              <van-col span="12">
                <span class="block">所属行业</span>
              </van-col>
              <van-col span="12">
                <span class="block">{{ urlItem ? urlItem.industryName : "--" }}</span>
              </van-col>
            </van-row>
          </van-col>

          <van-col span="12">
            <van-row>
              <van-col span="12">
                <span class="block">跟踪频度</span>
              </van-col>
              <van-col span="12">
                <span class="block">{{ urlItem && urlItem.factor ? urlItem.factor.updateFreqStr : "--" }}</span>
              </van-col>
            </van-row>
          </van-col>
        </van-row>

        <van-row>
          <van-col span="12">
            <van-row>
              <van-col span="12">
                <span class="block">当期涨幅</span>
              </van-col>
              <van-col span="12">
                <span class="block" :class="[judgeColor(urlItem && urlItem.curZf)]">
                  {{ toFixedNum(urlItem && urlItem.curZf, 2, "%") }}
                </span>
              </van-col>
            </van-row>
          </van-col>

          <van-col span="12">
            <van-row>
              <van-col span="12">
                <span class="block">近七日涨幅</span>
              </van-col>
              <van-col span="12">
                <span class="block" :class="[judgeColor(urlItem && urlItem.d7Zf)]">
                  {{ toFixedNum(urlItem && urlItem.d7Zf, 2, "%") }}
                </span>
              </van-col>
            </van-row>
          </van-col>
        </van-row>

        <van-row>
          <van-col span="12">
            <van-row>
              <van-col span="12">
                <span class="block">近30日涨幅</span>
              </van-col>
              <van-col span="12">
                <span class="block" :class="[judgeColor(urlItem && urlItem.d30Zf)]">
                  {{ toFixedNum(urlItem && urlItem.d30Zf, 2, "%") }}
                </span>
              </van-col>
            </van-row>
          </van-col>

          <van-col span="12">
            <van-row>
              <van-col span="12">
                <span class="block">近60日涨幅</span>
              </van-col>
              <van-col span="12">
                <span class="block" :class="[judgeColor(urlItem && urlItem.d60Zf)]">
                  {{ toFixedNum(urlItem && urlItem.d60Zf, 2, "%") }}
                </span>
              </van-col>
            </van-row>
          </van-col>
        </van-row>

        <van-row>
          <van-col span="12">
            <van-row>
              <van-col span="12">
                <span class="block">近90日涨幅</span>
              </van-col>
              <van-col span="12">
                <span class="block" :class="[judgeColor(urlItem && urlItem.d90Zf)]">
                  {{ toFixedNum(urlItem && urlItem.d90Zf, 2, "%") }}
                </span>
              </van-col>
            </van-row>
          </van-col>

          <van-col span="12">
            <van-row>
              <van-col span="12">
                <span class="block">年初至今</span>
              </van-col>
              <van-col span="12">
                <span class="block" :class="[judgeColor(urlItem && urlItem.ys2curZf)]">
                  {{ toFixedNum(urlItem && urlItem.ys2curZf, 2, "%") }}
                </span>
              </van-col>
            </van-row>
          </van-col>
        </van-row>
      </div>
    </div>

    <p style="height: 0.13rem; background: #f7f8fa"></p>

    <div class="card">
      <p class="h1">行业走势</p>

      <div class="hyzs">
        <!-- <div class="k_desc">
          <div class="left">
            <p class="color1"></p>
            <p>参考价[库存天数：坯布：终端织造]</p>
            <p class="color2"></p>
            <p class="color3"></p>
            <p>煤炭行情</p>
          </div>
          <p class="unit">元</p>
        </div> -->

        <div id="kLine" class="kLine" v-show="times.length"></div>

        <van-empty :description="description" v-if="!times.length" />
      </div>
    </div>

    <p style="height: 0.13rem; background: #f7f8fa"></p>

    <div class="card">
      <p class="h1 glgg">
        关联个股
        <!-- <img src="@/assets/images/arrow.png" alt="" class="arrow" /> -->
      </p>

      <ul class="header_tab" ref="headerTab">
        <li class="fixed-column">股票</li>
        <li>主营业务占比</li>
        <li>最新价</li>
        <li>涨幅</li>
        <li>成交额</li>
        <li>换手</li>
        <li>净流入额</li>
        <li>25日活跃度飘红</li>
        <li>个股强度</li>
        <li>资金先锋</li>
      </ul>

      <div class="hy_list" ref="hyList">
        <ul v-for="(item, index) in newGlggList" :key="index" class="ul" @click="goToFs(item.stock)">
          <li class="van-multi-ellipsis--l2 fixed-column">
            <p>{{ item.stockName }}</p>
            <p>{{ item.stock ? item.stock : "--" }}</p>
          </li>
          <li>
            <p>{{ item.zyywyszb }}</p>
            <p>{{ item.zyyw }}</p>
          </li>
          <li>{{ item.ZuiXinJia }}</li>
          <li :class="[judgeColor(item.ZhangFu)]">
            {{ toFixedNum(item.ZhangFu, 2, "%") }}
          </li>
          <li :class="[judgeColor(item.ChengJiaoE)]">
            {{ formatAmount(item.ChengJiaoE) }}
          </li>
          <li :class="[judgeColor(item.HuanShou)]">{{ item.HuanShou }}</li>
          <li :class="[judgeColor(item.ZongMaiRu)]">
            {{ formatAmount(item.ZongMaiRu) }}
          </li>

          <li>{{ item.YXDS_AI_HYD }}</li>
          <li :class="[judgeColor(item.GGQD)]">{{ item.GGQD }}</li>
          <li :class="[judgeColor(item.ZJXFKLINE)]">{{ item.ZJXFKLINE }}</li>
        </ul>
      </div>

      <van-empty description="暂无数据" v-if="glggList.length == 0" />

      <!-- 如果有3062或者504 并且在安卓里面  任意一个权限就可以查看  如果都没有就展示机会宝购买  banner -->
      <div class="shade_bg" v-if="!isVip3062 && !isVip504 && !isVip6yuan">
        <div class="qlyj_banner">
          <p class="banner_jhb">
            <img src="../assets/images/banner_jhb_h53.png" alt="" />
          </p>
          <p class="p1">{{ urlItem?.industryName }}产业图谱</p>
          <p class="p2">监测产品涨价波动，发现业绩增长潜力</p>
          <button class="banner_btn" @click="handleClickSingle">
            ¥
            <span>6</span>
            解锁 &gt;&gt;
          </button>
          <p class="p3" style="text-align: left">购买后有效期30天，请及时保存</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "HyqjDetail",
    data() {
      return {
        chartDom: null,
        urlItem: {},
        kData: [],
        themeStyleVs: 1,
        times: [],
        bLineData: [],
        glggList: [],
        yunToken: "",
        newGlggList: [],
        description: "加载中",
        isVip3062: true,
        isVip504: true,
        isVip6yuan: true,
        token: "",
      };
    },
    components: {},
    watch: {},
    computed: {},
    created() {
      this.getHeaderInfo();
    },
    async mounted() {
      this.token = this.getUrlQuery("token");
      this.getVip("3062,504");
      this.themeStyleVs = this.getUrlQuery("themeStyleVs");
      this.$refs.hyList.addEventListener("scroll", this.syncScroll);
      this.$refs.headerTab.addEventListener("scroll", this.syncScroll);
    },

    beforeDestroy() {
      this.$refs.hyList.removeEventListener("scroll", this.syncScroll);
      this.$refs.headerTab.removeEventListener("scroll", this.syncScroll);
    },
    methods: {
      getUrlQuery: function (name) {
        var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
        var r = window.location.search.substr(1).match(reg); // search,查询？后面的参数，并匹配正则
        if (r != null) return unescape(r[2]);
        return null;
      },
      // 检测是否是iOS设备
      isiOS: function () {
        return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
      },

      // 检测是否是Android设备
      isAndroid: function () {
        return /Android/.test(navigator.userAgent);
      },

      // 是否是vip
      getVip(need) {
        let _this = this;
        let needsArray = need.split(","); // 将输入的字符串按逗号分割成数组
        let promises = needsArray.map((needItem) => {
          return _this.$http({
            method: "get",
            url: window.config.vip_server + "/power/chkAllowedInIp",
            params: {
              need: needItem,
              pname: "jhb",
              token: _this.token,
            },
          });
        });

        Promise.all(promises)
          .then((results) => {
            // 第一个结果的处理
            if (results[0].data.err == 0) {
              _this.isVip3062 = results[0].data.data;
            } else {
              _this.isVip3062 = false;
            }

            // 第二个结果的处理
            if (results[1].data.err == 0) {
              _this.isVip504 = results[1].data.data;
            } else {
              _this.isVip504 = false;
            }

            console.log(_this.isVip3062, "3062", _this.isVip504, "504");

            //如果没有3062和504权限再走6元单个权限判断
            if (!_this.isVip3062 && !_this.isVip504) {
              _this.get6Vip(_this.token);
            }
          })
          .catch((error) => {
            // 处理请求中的错误
            console.error("Error checking VIP status:", error);
            _this.isVip3062 = false;
            _this.isVip504 = false;
            _this.$forceUpdate();
          });
      },

      get6Vip: function (token) {
        var _this = this;
        return _this
          .$http({
            method: "get",
            url: window.config.vip_server + "/power/checkPowerForId",
            params: {
              pid: _this.$route.query.indexId, //id
              type: 2, //1.图谱数据,2.产业数据
              token: token,
            },
          })
          .then(function (res) {
            if (res.data.err != 200) {
              _this.isVip6yuan = false;
            } else {
              _this.isVip6yuan = true;
            }

            console.log(_this.isVip6yuan, "6元权限");
          })
          .catch(function () {
            _this.isVip3062 = false;
            _this.isVip504 = false;
            _this.isVip6yuan = false;
          });
      },

      handleClickSingle: function () {
        var url = window.config.pay6yuan_url + "?DZHSPECIAL=48&infoBussType=7&productCode=" + this.getUrlQuery("indexId") + "&s=151&token=" + this.token;
        this.toUrl(url);
      },

      getHeaderInfo: function () {
        let _this = this;
        _this
          .$http({
            method: "get",
            url: window.config.api_v5 + "/research-industry-sdk/industry-prosperity/get",
            params: {
              indexId: _this.$route.query.indexId,
              qid: new Date().getTime(),
            },
            headers: {
              Token: _this.$route.query.token,
            },
          })
          .then(function (res) {
            _this.urlItem = res.data.data;
            _this.getYstr();
          })
          .catch(function (err) {
            console.log(err);
          });
      },

      /**
       * 将金额转换为带单位的字符串
       * @param {number} amount - 需要转换的金额
       * @param {number} [decimal=2] - 小数位数，默认保留2位小数
       * @returns {string} - 带单位的金额字符串，如果输入不合法，返回'--'
       */
      formatAmount(amount, decimal = 2) {
        if (isNaN(amount)) {
          return "--";
        }

        const units = ["元", "万", "亿", "万亿"];
        let unitIndex = 0;
        let formattedAmount = amount;

        while (formattedAmount >= 10000 && unitIndex < units.length - 1) {
          formattedAmount /= 10000;
          unitIndex++;
        }

        return formattedAmount.toFixed(decimal) + units[unitIndex];
      },
      syncScroll(event) {
        if (event.target === this.$refs.hyList) {
          this.$refs.headerTab.scrollLeft = event.target.scrollLeft;
        } else if (event.target === this.$refs.headerTab) {
          this.$refs.hyList.scrollLeft = event.target.scrollLeft;
        }
      },
      //返回股票涨幅对应的颜色
      judgeColor: function (n) {
        if (n == 0) {
          return "gray";
        } else if (n > 0) {
          return "red";
        } else if (n < 0) {
          return "green";
        }
      },

      toFixedNum: function (value, toFixed = 2, unit = "") {
        if (value && value !== "--") {
          return Number(value).toFixed(toFixed) + unit;
        } else if (value === 0) {
          return "0.00" + unit;
        } else {
          return "--";
        }
      },
      onClickLeft: function () {
        // this.$router.go(-1);
        this.toUrl("134");
      },
      getYstr: function () {
        let _this = this;
        _this
          .$http({
            method: "get",
            url: window.config.api_v2 + "/Auth/getYstr",
            params: {},
          })
          .then(function (res) {
            _this.yunToken = res.data;
            _this.getQuoteKLine(res.data);
            _this.getGlggList();
          });
      },

      getCurrentDateFormatted: function (i = "") {
        const now = new Date();
        now.setFullYear(now.getFullYear() - 1); // 往前推一年
        const year = now.getFullYear();
        const month = String(now.getMonth() + 1).padStart(2, "0"); // getMonth() 返回值是 0-11，所以需要加 1
        const day = String(now.getDate()).padStart(2, "0");

        return `${year}${i}${month}${i}${day}`;
      },

      getCurrentDateFormatted2: function (i = "") {
        const now = new Date();
        now.setFullYear(now.getFullYear()); // 往前推一年
        const year = now.getFullYear();
        const month = String(now.getMonth() + 1).padStart(2, "0"); // getMonth() 返回值是 0-11，所以需要加 1
        const day = String(now.getDate()).padStart(2, "0");

        return `${year}${i}${month}${i}${day}`;
      },

      getQuoteKLine: function (token) {
        let _this = this;
        _this.description = "加载中";
        _this
          .$http({
            method: "get",
            url: window.config.api_v3 + "/quote/kline",
            params: {
              obj: _this.urlItem ? _this.urlItem.yptIndustryCode : "",
              token: token,
              period: "1day",
              field: "KaiPanJia,ShouPanJia,ZuiDiJia,ZuiGaoJia",
              begin_time: _this.getCurrentDateFormatted(),
            },
          })
          .then(function (res) {
            if (res.data.Data.JsonTbl.data[0][0].data[0][1].data) {
              let v = res.data.Data.JsonTbl.data[0][0].data[0][1].data;
              let k = [];
              let t = [];
              let ts = [];
              v.forEach((item) => {
                const [timestamp] = item;
                t.push(_this.formatDate(timestamp));
              });

              ts = _this.getAllDates(t[0], t[t.length - 1]);
              ts.forEach((item) => {
                _this.times.push(_this.formatDate(item));
              });

              k = _this.mapData(v, ts);

              // // 交换 [1] 和 [3] 位置的值
              let nk = _this.swapPositions(k, 1, 3);
              _this.kData = nk;

              _this.getBrokenLine();
            } else {
              _this.description = "暂无数据";
              _this.times = [];
            }
          })
          .catch(() => {
            _this.description = "暂无数据";
            _this.times = [];
          });
      },

      getBrokenLine: function () {
        let _this = this;
        _this
          .$http({
            method: "post",
            url: window.config.api_v4 + "/research-framework-server/rf/fm/idx/fvs",
            data: {
              param: {
                factorId: _this.$route.query.indexId,
                repDate: _this.getCurrentDateFormatted2("-"),
              },
              qid: new Date().getTime(),
            },
            headers: {
              token: _this.$route.query.token,
            },
          })
          .then(function (res) {
            let b = res.data.data;

            _this.bLineData = _this.replaceDates(b, _this.times);
            _this.drawKLine();
          });
      },

      // 日期格式化函数
      formatDate: function (timestamp) {
        const date = new Date(timestamp * 1000); // 转换为毫秒
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0"); // 月份从0开始
        const day = String(date.getDate()).padStart(2, "0");
        return `${year}-${month}-${day}`;
      },

      //数组位置互换
      swapPositions: function (arr, pos1, pos2) {
        // 遍历每一条数据进行位置互换
        arr.forEach((subArr) => {
          if (Array.isArray(subArr) && subArr.length > Math.max(pos1, pos2)) {
            let temp = subArr[pos1];
            subArr[pos1] = subArr[pos2];
            subArr[pos2] = temp;
          }
        });

        return arr;
      },

      //组成折线数据  对应k线最大和最小日期补全的数据 然后填入折线的数据 中间的空值 赋值上一个日期的数据 最后一个折线日期之后的折线日期数据补空
      replaceDates(arr1, time) {
        const result = [];
        let lastValidValue = null; // 保存上一个有效值

        for (let i = 0; i < time.length; i++) {
          const found = arr1.find((item) => item.t === time[i]);

          if (found) {
            result.push(found.v);
            lastValidValue = found.v; // 更新上一个有效值为当前找到的值
          } else if (new Date(time[i]) > new Date(arr1[arr1.length - 1].t)) {
            result.push(""); // 如果时间超过了 arr1 中的最后一个日期，则设置为空
          } else {
            result.push(lastValidValue || ""); // 否则设置为上一个有效值或空
          }
        }

        return result;
      },

      //把K线数据和全部日期对应起来赋值
      mapData(data1, data2) {
        const data1Map = new Map(data1.map((item) => [item[0], item.slice(1)]));
        return data2.map((timestamp) => data1Map.get(timestamp) || []);
      },

      //传入一个最小日期和一个最大日期，返回一个包含所有日期时间戳的数组
      getAllDates(minDate, maxDate) {
        const startDate = new Date(minDate);
        const endDate = new Date(maxDate);
        const dateArray = [];

        let currentDate = startDate;
        while (currentDate <= endDate) {
          // 将小时、分钟、秒和毫秒设置为0以确保00:00:00
          currentDate.setHours(0, 0, 0, 0);
          const timestamp = Math.floor(currentDate.getTime() / 1000);
          dateArray.push(timestamp);
          currentDate.setDate(currentDate.getDate() + 1);
        }

        return dateArray;
      },
      drawKLine() {
        let _this = this;
        if (!_this.chartDom) {
          _this.chartDom = _this.$echarts.init(document.getElementById("kLine"));
        } else {
          _this.chartDom.dispose();
          _this.chartDom = _this.$echarts.init(document.getElementById("kLine"));
        }
        // 默认展示50条数据
        // var start = Math.floor((1 - 50 / _this.times.length) * 100);
        var dataZoom = [
          {
            type: "inside",
            xAxisIndex: [0, 1],
            start: 50,
            end: 100,
          },
          {
            type: "slider",
            start: 50,
            end: 100,
            xAxisIndex: [0, 1],
            left: 7,
            right: 12,
            bottom: 10,
            brushSelect: false,
            handleSize: 20,
            handleIcon: "image://images/handle.png",
            handleStyle: {
              color: "#fff",
            },
            height: 20,
            backgroundColor: "rgba(250, 250, 250, 1)",
            borderColor: "rgba(250, 250, 250, 1)",

            //     backgroundColor:
            //   _this.themeStyleVs == 1
            //     ? "rgba(250, 250, 250, 1)"
            //     : "rgba(30, 32, 43, 1)",
            // borderColor:
            //   _this.themeStyleVs == 1
            //     ? "rgba(250, 250, 250, 1)"
            //     : "rgba(30, 32, 43, 1)",
          },
        ];
        var option = {
          grid: {
            top: 30,
            bottom: 40,
            left: 50,
            right: 40,
          },
          tooltip: {
            trigger: "axis",
            axisPointer: {
              type: "cross",
            },
            extraCssText: "z-index: 8;", // 设置 z-index
            formatter: (params) => {
              var paramsK = params[0];
              var value = paramsK.axisValue + ":<br/>" + _this.urlItem.industryName + "<br/>开盘价：" + (paramsK.data[1] ? paramsK.data[1] : "--") + "<br/>收盘价：" + (paramsK.data[2] ? paramsK.data[2] : "--") + "<br/>最低价：" + (paramsK.data[3] ? paramsK.data[3] : "--") + "<br/>最高价：" + (paramsK.data[4] ? paramsK.data[4] : "--") + "<br/>折线图数据：" + (params[1]?.data ? params[1]?.data : 0);

              return value;
            },
          },
          xAxis: [
            {
              // 指标提示提示icon
              position: "bottom",
              offset: 15,
              type: "category",
              data: _this.times,
              axisLine: { show: false },
              axisTick: { show: false },
              splitLine: { show: false },
            },
          ],
          yAxis: [
            {
              type: "value",
              splitLine: {
                show: true,
                lineStyle: {
                  color: "rgba(0,0,0,0.1)",
                  width: 0.5,
                },
              },
              axisLabel: {
                color: "rgba(0,0,0,0.3)",
                formatter: function (value) {
                  return value.toFixed(2);
                },
                fontSize: 10,
                margin: 5,
              },
              max: function (value) {
                return Math.floor(value.max) + 2;
              },
              min: function (value) {
                return Math.floor(value.min) - 2;
              },
            },
            {
              name: "元",
              nameTextStyle: {
                color: "rgba(0,0,0,0.25)",
                fontSize: 10,
                padding: [0, 0, 0, 7],
              },
              type: "value",
              splitLine: {
                show: false,
              },
              axisLabel: {
                color: "rgba(0,0,0,0.3)",
                fontSize: 10,
                margin: 5,
              },
              max: function (value) {
                return Math.floor(value.max) + 1;
              },
              min: function (value) {
                return Math.floor(value.min) - 1;
              },
            },
          ],
          series: [
            {
              type: "candlestick",
              data: _this.kData,
              yAxisIndex: 1,
            },
            {
              data: _this.bLineData,
              name: "折线图数据:",
              type: "line",
              symbolSize: 0,
              lineStyle: {
                width: 2,
                color: _this.themeStyleVs == 1 ? "#286DF7" : "#3B85FE",
              },
              // step: "middle", // 设置为 'middle' 实现横平竖直效果
              // connectNulls: true, // 这里设置为 true 表示连接间断的数据点
              smooth: true,
            },
          ],
        };
        if (_this.times.length > 50) {
          // 超过100条，出现滚动条
          option.dataZoom = dataZoom;
          option.grid.bottom = 75;
        }
        _this.chartDom.setOption(option);
      },

      //获取所有的 stock 值并去重
      getUniqueStocks(data) {
        const stocks = data.map((item) => item.stock);
        const uniqueStocks = [...new Set(stocks)];
        return uniqueStocks;
      },

      // 25日飘红天数: http://10.15.144.131/indicator/calc/dyna?name=YXDS_AI_HYD&orderbypos=9&field=obj,value&obj=SZ002304,SZ002305,SZ002306,SZ002307,SZ002308,SZ002309,SZ002310
      // 个股强度: http://10.15.144.131/indicator/calc/dyna?name=GGQD&orderbypos=0&field=obj,value&obj=SZ002304,SZ002305,SZ002306,SZ002307,SZ002308,SZ002309,SZ002310
      // 资金先锋: http://10.15.144.131/indicator/calc/dyna?name=ZJXFKLINE&orderbypos=0&field=obj,value&obj=SZ002304,SZ002305,SZ002306,SZ002307,SZ002308,SZ002309,SZ002310

      // PS: obj批量请求时，一次给的股票不允许超过200只

      //获取关联个股
      getGlggList: function () {
        let _this = this;
        _this
          .$http({
            method: "post",
            url: window.config.api_v1 + "/research-industry-sdk/industry-prosperity/stock-main-busi",
            data: {
              pageNum: 1,
              pageSize: 20,
              param: {
                factorId: _this.$route.query.indexId,
              },
              qid: new Date().getTime(),
            },
            headers: {
              token: _this.$route.query.token,
            },
          })
          .then(function (res) {
            if (res.data.data && res.data.data.length) {
              _this.glggList = res.data.data;
              _this.getHqList(_this.getUniqueStocks(res.data.data));
            } else {
              _this.description = "暂无数据";
              _this.times = [];
              _this.glggList = [];
            }
          });
      },

      //根据股票代码合并数据
      mergeData: function (hqList, zhangfu) {
        // 创建一个映射表，快速查找zhangfu数据
        const zhangfuMap = zhangfu.reduce((map, item) => {
          map[item.Obj] = item;
          return map;
        }, {});

        // 遍历hqList，将对应的zhangfu数据合并到每个条目中
        const mergedArr = hqList.map((item) => {
          const match = zhangfuMap[item.stock];
          if (match) {
            return {
              ...item,
              ZuiXinJia: match.ZuiXinJia,
              ZhangFu: match.ZhangFu,
              ChengJiaoE: match.ChengJiaoE,
              HuanShou: match.HuanShou,
              ZongMaiRu: match.ZongMaiRu,
            };
          }
          return item;
        });

        return mergedArr;
      },

      //获取行情
      getHqList: function (stock) {
        let _this = this;
        _this
          .$http({
            method: "get",
            url: window.config.api_v3 + "/quote/stkdata",
            params: {
              obj: stock.toString(),
              field: "ZhangFu,ZuiXinJia,ZongMaiRu,ZongMaiChu,HuanShou,ChengJiaoE,ZhongWenJianCheng",
              token: _this.yunToken,
            },
          })
          .then(function (res) {
            _this.newGlggList = _this.mergeData(_this.glggList, res.data.Data.RepDataStkData);

            _this.getZjOrGgOrHydFun(stock.toString(), _this.yunToken);
          });
      },

      async getZjOrGgOrHydFun(obj, token) {
        const _this = this; // 保存当前的 Vue 实例的引用，方便在异步函数中使用
        const names = ["YXDS_AI_HYD", "GGQD", "ZJXFKLINE"]; // 要依次传递的参数名数组
        const results = []; // 用于存储所有请求结果的数组

        // Helper function to make a single request
        // 辅助函数，用于执行单次请求
        async function makeRequest(name) {
          const url = window.config.zjOrGgOrHyd + `/indicator/calc/dyna?name=${name}&orderbypos=${name === "YXDS_AI_HYD" ? 9 : 0}&field=obj,value&obj=${obj}&token=${token}`;
          try {
            const res = await _this.$http({ method: "get", url: url });
            const newItems = res.data.Data.RepDataZBDynaShuJu;

            results[name] = newItems; // 将当前请求的结果存储到 results 对象中，以 name 为键

            // 如果请求返回的数据不为空，则更新 oldItem 中的 Value 属性
            if (newItems.length) {
              newItems.forEach((newItem) => {
                _this.newGlggList.forEach((oldItem) => {
                  if (oldItem.stock === newItem.Obj) {
                    _this.$set(oldItem, name, newItem.Value !== undefined ? newItem.Value : "--");
                  }
                });
              });
            }
          } catch (err) {
            console.error(err); // 如果请求出错，则打印错误信息
          }
        }

        // 通过 for...of 循环依次遍历 names 数组，并顺序执行每个请求
        for (const name of names) {
          await makeRequest(name); // 等待当前请求完成后再进行下一个请求
        }
      },

      //跳转原生分时
      goToFs: function (stockCode) {
        let newCode = stockCode.replace("B$", "BI");
        if (window.navigator.userAgent.indexOf("dzhapp") !== -1 || typeof window.DzhAppJs != "undefined") {
          this.toUrl(`dzh_browser_url&goto=0&type=2970&code=${newCode}&kind=1`);
        } else {
          let d = `dzh_browser_url&goto=0&type=2970&code=${newCode}&kind=1`;
          let url = encodeURIComponent(d);
          this.toUrl(`https://dzhopenapp.gw.com.cn/openapp/download.html?info=${url}`);
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
  .red {
    color: #ef3939 !important;
  }
  .green {
    color: #1eac4e !important;
  }
  .gray {
    color: #999;
  }
  .HyqjDetail {
    margin: 0 auto;
    background: #fff;
    min-height: 100vh;
    .nav_bar {
      background: #fff;
      position: sticky;
      top: 0;
      left: 0;
      width: 100%;
      z-index: 9;
      padding-top: 0.3rem;
      ::v-deep {
        .van-icon {
          color: #333;
          font-size: 0.16rem;
        }
        .van-nav-bar__title {
          color: #222;
          font-size: 0.16rem;
          font-weight: 800;
        }
      }
    }
    .card {
      padding: 0.16rem;
      .h1 {
        font-weight: 800;
        color: #1d2129;
        font-size: 0.16rem;
        margin-bottom: 0.1rem;
      }
      .info {
        .block {
          color: #4e5969;
          font-size: 0.14rem;
          padding: 0.06rem 0;
          display: block;
        }
      }
      .hyzs {
        .k_desc {
          display: flex;
          align-items: center;
          justify-content: space-between;
          .left {
            display: flex;
            align-items: center;
            color: #999;
            font-size: 0.12rem;
            .color1 {
              width: 0.08rem;
              height: 0.03rem;
              background: #286df7;
              margin-right: 0.05rem;
            }
            .color2 {
              width: 0.05rem;
              height: 0.05rem;
              background: #f54d5b;
              margin-left: 0.1rem;
              margin-right: 0.02rem;
            }
            .color3 {
              width: 0.05rem;
              height: 0.05rem;
              background: #45d36d;
              margin-right: 0.05rem;
            }
          }
          .unit {
            color: #999;
            font-size: 0.1rem;
          }
        }
        .kLine {
          height: 3rem;
        }
      }

      .glgg {
        position: relative;
        .arrow {
          position: absolute;
          width: 0.06rem;
          height: 0.06rem;
          right: -0.1rem;
          top: 0.4rem;
        }
      }

      .header_tab {
        display: flex;
        align-items: center;
        overflow-x: auto;
        position: relative;

        li {
          color: #999;
          font-size: 0.14rem;
          text-align: right;
          width: 0.8rem;
          flex-shrink: 0;
          text-align: center;
          &:first-child {
            text-align: left;
          }
          &:nth-child(2) {
            text-align: left;
            width: 1rem;
          }
          &:nth-child(8) {
            width: 1.2rem;
          }
        }
      }

      .fixed-column {
        position: sticky;
        left: 0;
        background-color: white;
        z-index: 1;
        flex-shrink: 0;
        width: 0.7rem;
      }

      .hy_list {
        overflow-x: auto;
        ul {
          display: flex;
          align-items: center;
          width: max-content;
          li {
            text-align: right;
            font-size: 0.14rem;
            width: 0.8rem;
            flex-shrink: 0;
            text-align: center;
            &:first-child {
              text-align: left;
              padding: 0.125rem 0;
            }
            &:nth-child(1),
            &:nth-child(2) {
              p {
                &:first-child {
                  font-weight: 800;
                  color: #1d2129;
                  font-size: 0.16rem;
                }
                &:last-child {
                  color: #999;
                  font-size: 0.12rem;
                }
              }
            }
            &:nth-child(2) {
              width: 1rem;
              text-align: left;
            }
            &:nth-child(3) {
              font-weight: 800;
              color: #1d2129;
            }
            &:nth-child(4) {
              font-weight: 800;
            }
            &:nth-child(8) {
              width: 1.2rem;
            }
          }
        }
      }
    }
  }

  .shade_bg {
    position: fixed;
    width: 100vw;
    height: 100vh;
    left: 0;
    top: 0;
    z-index: 99;
    background: rgba(0, 0, 0, 0.7);
    backdrop-filter: blur(3px); /* 添加模糊效果 */
    -webkit-backdrop-filter: blur(3px); /* 兼容 Safari */

    .qlyj_banner {
      width: 100%;
      height: 2.2rem;
      position: absolute;
      bottom: 0;
      z-index: 100;
      text-align: center;
      border-radius: 0.3rem 0.3rem 0 0;
      overflow: hidden;
      background: url("../assets/images/qlyj_banner.jpg");
      background-size: cover;
      padding: 0.13rem 0.3rem;
      .banner_jhb {
        width: 1.2rem;
        height: 0.3rem;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .p1,
      .p2 {
        font-weight: 700;
        color: #ffffff;
        font-size: 0.14rem;
        margin-top: 0.08rem;
        text-align: left;
      }
      .banner_btn {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 0.08rem;
        width: 100%;
        height: 0.46rem;
        background: linear-gradient(95.1deg, #ffc37c -0.46%, #fff1d5 100%);
        border-radius: 60px;
        box-shadow: 0px 4px 4px rgba(255, 255, 255, 0.25) inset, 0px 1px 0px #f3c998 inset;
        color: #c72d25;
        font-size: 0.16rem;
        font-weight: 600;
        span {
          font-weight: 700;
          font-size: 0.28rem;
          margin: 0 0.05rem;
        }
      }
      .p3 {
        color: #ffffff;
        font-size: 0.12rem;
        margin-top: 0.08rem;
      }
    }
  }
</style>
